"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var helpers_1 = require("../../helpers");
var jquery_1 = __importDefault(require("jquery"));
var message_files_1 = __importDefault(require("./message-files"));
function MessageBubble(_a) {
    var message = _a.message, openChat = _a.openChat, contacts = _a.contacts;
    var isMessageFromUser = openChat.user_role === message.sender_type;
    var correspondingRequest = (function (message) {
        var filteredRequests = openChat.requests.filter(function (request) {
            return new Date(request.created).getTime() <=
                new Date(message.created).getTime();
        });
        var sortedRequests = (0, helpers_1.sortFromLatestToOldest)(filteredRequests);
        return sortedRequests[sortedRequests.length - 1];
    })(message);
    var _b = (0, helpers_1.hasUnregisteredData)({
        paymentMethods: openChat.rental.payment_methods,
        contacts: contacts,
        messageString: message.message ? message.message : "",
    }), hasUnregisteredIban = _b.hasUnregisteredIban, hasUnregisteredEmail = _b.hasUnregisteredEmail, unregisteredDataCount = _b.unregisteredDataCount;
    (0, react_2.useEffect)(function () {
        (0, jquery_1.default)(".chat-message-bubble").each(function () {
            (0, jquery_1.default)(this).magnificPopup({
                delegate: ".img-popup",
                type: "image",
                gallery: {
                    enabled: true,
                },
                image: {
                    markup: "\n              <div class=\"mfp-figure\">\n                <div class=\"mfp-close\"></div>\n                <button class=\"mfp-download btn btn--tertiary btn--ss\" style=\"\n                  position: absolute;\n                  right: 40px;\n                  top: 8px;\n                \">\n                  <svg class=\"icon mb-0\" width=\"18\" height=\"18\">\n                    <use href=\"#download\" />\n                  </svg>\n                  Download\n                </button>\n                <div class=\"mfp-img\"></div>\n                <div class=\"mfp-bottom-bar\">\n                  <div class=\"mfp-counter\"></div>\n                </div>\n              </div>",
                },
                preloader: false,
                callbacks: {
                    open: function () {
                        (0, jquery_1.default)(".mfp-download").on("click", function (e) {
                            e.preventDefault();
                            window.location.href = this.currItem.src;
                        }.bind(this));
                    },
                },
            });
        });
    }, []);
    var renderWithLineBreaks = function (text) {
        return text.split("\n").map(function (line, index) { return (react_1.default.createElement(react_2.Fragment, { key: index },
            line,
            react_1.default.createElement("br", null))); });
    };
    return (react_1.default.createElement("div", { className: "message d-flex mb-2 w-75 gap-2".concat(isMessageFromUser
            ? " me-3 justify-content-end align-self-end"
            : " ms-3 justify-content-start align-self-start") },
        !isMessageFromUser && correspondingRequest !== undefined && (react_1.default.createElement("div", { className: "chat-message-name-initials tooltip-trigger text smaller gray flex-shrink-0 mobile-hidden" },
            correspondingRequest.name.slice(0, 1).toUpperCase(),
            correspondingRequest.surname.slice(0, 1).toUpperCase(),
            react_1.default.createElement("span", { className: "tooltip nw p-1 text small shadow" },
                correspondingRequest.name,
                " ",
                correspondingRequest.surname))),
        react_1.default.createElement("div", { className: "chat-message-bubble d-flex flex-column gap-1".concat(isMessageFromUser ? " user" : " other-user") },
            message.files.length > 0 && react_1.default.createElement(message_files_1.default, { message: message }),
            message.message &&
                (message.type == "HTML" ? (react_1.default.createElement("div", { className: "px-1 message-message", dangerouslySetInnerHTML: { __html: message.message } })) : (react_1.default.createElement("div", { className: "px-1" }, renderWithLineBreaks(message.message)))),
            react_1.default.createElement("span", { className: "px-1 d-flex smaller align-items-end gap-2".concat(isMessageFromUser && unregisteredDataCount > 0
                    ? " justify-content-between"
                    : " align-self-end") },
                isMessageFromUser && unregisteredDataCount > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: "tooltip-trigger", style: {
                            backgroundColor: "#ebb000",
                            padding: "4px",
                            borderRadius: "5px",
                        } },
                        react_1.default.createElement("svg", { className: "icon mb-0", width: "15", height: "15" },
                            react_1.default.createElement("use", { href: "#info" })),
                        " ",
                        window.Translator.trans("chat.unregistered_data.hint", {}, "js"),
                        react_1.default.createElement("span", { className: "tooltip unregistered-data nw p-1 text small shadow" },
                            react_1.default.createElement("ul", null,
                                hasUnregisteredIban && (react_1.default.createElement("li", { className: unregisteredDataCount > 1 ? "mb-1" : "", dangerouslySetInnerHTML: {
                                        __html: window.Translator.trans("chat.unregistered_data.landlord.iban", {
                                            route_payment_methods: window.Routing.generate("payment_methods", {
                                                _locale: lang,
                                            }),
                                        }, "js"),
                                    } })),
                                hasUnregisteredEmail && (react_1.default.createElement("li", { className: unregisteredDataCount > 1 ? "mb-1" : "", dangerouslySetInnerHTML: {
                                        __html: window.Translator.trans("chat.unregistered_data.landlord.email", {
                                            route_account: window.Routing.generate("account", {
                                                _locale: lang,
                                            }),
                                            route_payment_methods: window.Routing.generate("payment_methods", {
                                                _locale: lang,
                                            }),
                                        }, "js"),
                                    } }))))))),
                react_1.default.createElement("span", { className: "text gray" }, (0, helpers_1.formatTimeMessage)(message.created))))));
}
exports.default = MessageBubble;
